import React from 'react';

const VERSION = "e5a5719c";
const ZINNIA_BETA_STYLESHEET_URL = `https://design-system-css.zapier.com/design-system-beta/${VERSION}.css`;
const ZinniaBetaStylesheet = (props) => {
  return React.createElement("link", Object.assign({ href: ZINNIA_BETA_STYLESHEET_URL, rel: "stylesheet" }, props));
};

export { ZINNIA_BETA_STYLESHEET_URL, ZinniaBetaStylesheet };
//# sourceMappingURL=ZinniaBetaStylesheet.es.js.map
